import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { NoResourceError } from '../../../shared/components/components/ui/error404';
import CreatorsContainer from './components/custom/CreatorsContainer';
// import SummaryPanel from './components/custom/SummaryPanel';


const ResourceAction = (props) => {
  const {
    resources,
    history,
    location,
    session,
  } = props;
  const [tag, setTag] = useState('');
  const brandName = session?.advertiser?.companyName || 'Brand';

  useEffect(() => {
    document.title = `${brandName} Brand Creators`;
  }, [brandName]);

  const resource = resources.find(r => r.id === 'Influencer');
  if (!resource) {
    return (<NoResourceError resourceId="Influencer" />);
  }
  const action = null;

  return (
    <Container >
      <Row>
        <Col>
          <h2 className="my-3">Creators</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <CreatorsContainer
            filterVisible
            tag={tag}
            setTag={setTag}
            resource={resource}
            action={action}
            date={new Date()}
            history={history}
            location={location}
          />
        </Col>
      </Row>
    </Container>
  );
};
ResourceAction.propTypes = {
  resources: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  session: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = state => ({
  resources: state.resources,
  session: state.session,
});

export default connect(mapStateToProps)(ResourceAction);
